// extracted by mini-css-extract-plugin
export default {"float-left":"Layout-module--float-left--0d9de","float-right":"Layout-module--float-right--52734","layout":"Layout-module--layout--2c933"};